// extracted by mini-css-extract-plugin
export default {"row":"Row_row__3UH4e","header":"Row_header__Cyhy1","descriptionCell":"Row_descriptionCell__MsMg1","descriptionText":"Row_descriptionText__xezGc"};